// Hands a blob to the browser as a download. Deliberately does not revoke the object URL straight
// after click(): Firefox and Safari can cancel the download when it disappears before the browser
// has read it.
// eslint-disable-next-line import/prefer-default-export
export function saveBlobAsFile(blob: Blob, filename: string | null | undefined) {
  const link = document.createElement('a')
  link.style.display = 'none'
  document.body.appendChild(link)
  link.href = URL.createObjectURL(blob)
  link.download = filename || 'download'
  link.click()
  document.body.removeChild(link)
}
